/**
 * Utilitaire pour parser les numéros de rue et séparer les bis/ter
 */
export const parseHouseNumber = (housenumber: string): { numero: string; complement: string } => {
    if (!housenumber) return { numero: '', complement: '' };

    // Regex pour séparer le numéro des suffixes (bis, ter, quater, A, B, etc.)
    const match = housenumber.match(/^(\d+)\s*([a-zA-Z]+|bis|ter|quater)?$/i);

    if (match) {
        return {
            numero: match[1] || '',
            complement: match[2] || '',
        };
    }

    // Si pas de match, essayer de séparer les chiffres du reste
    const numMatch = housenumber.match(/^(\d+)(.*)$/);
    if (numMatch) {
        return {
            numero: numMatch[1] || '',
            complement: numMatch[2].trim() || '',
        };
    }

    // Fallback : tout dans le numéro
    return { numero: housenumber, complement: '' };
};
